import * as React from 'react'
import Box from '@mui/material/Box'

import { ManageButton } from './ManageButton'
import { MarkCompleted } from './CompletedMark'
import { AppointmentDateTime } from '../../atoms'

interface Props {
  orderUrl: string
  appointmentId: string
  allowActions: boolean
  workTime: Date | null
  timeRange: string | null
  onOpenNestedDialog: (completeView: boolean) => void
}

export function ContentRight(props: Props) {
  const { onOpenNestedDialog, allowActions, orderUrl, appointmentId, ...rest } =
    props

  return (
    <Box
      flexBasis="150px"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
    >
      <AppointmentDateTime {...rest} mb={1.6} />
      {allowActions ? (
        <MarkCompleted
          onOpenNestedDialog={onOpenNestedDialog}
          appointmentId={appointmentId}
        />
      ) : (
        <ManageButton orderUrl={orderUrl} appointmentId={appointmentId} />
      )}
    </Box>
  )
}
